import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on route (pathname) changes,
 * but NOT when the change is triggered by a language switch.
 * If a hash is present, scroll to that element instead.
 */
export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.langSwitch) return;

    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Wait for the target route to render its section
      const attempts = [50, 150, 350, 700];
      attempts.forEach((delay) => {
        window.setTimeout(() => {
          const el = document.getElementById(id);
          if (el) {
            const y = el.getBoundingClientRect().top + window.pageYOffset - 80;
            window.scrollTo({ top: y, left: 0, behavior: "instant" });
          }
        }, delay);
      });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname, location.hash]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
